import axios from "axios";
import { BACKEND_URL } from "@/lib/env";
import { formatAdminApiError } from "@/lib/adminUsersApi";

const BASE = `${BACKEND_URL}/api/admin/groups`;

export { formatAdminApiError };

/** List roles (system + custom) for assignment and Group Management. */
export async function listAdminGroups(q) {
  const { data } = await axios.get(BASE, { params: q ? { q } : undefined });
  return data;
}

export async function getAdminGroup(slug) {
  const { data } = await axios.get(`${BASE}/${encodeURIComponent(slug)}`);
  return data;
}

export async function createAdminGroup(body) {
  const { data } = await axios.post(BASE, body);
  return data;
}

export async function updateAdminGroup(slug, body) {
  const { data } = await axios.patch(`${BASE}/${encodeURIComponent(slug)}`, body);
  return data;
}

export async function deleteAdminGroup(slug) {
  const { data } = await axios.delete(`${BASE}/${encodeURIComponent(slug)}`);
  return data;
}
